import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { firebaseConfig } from '../../../constant.var';
import { WindowService } from '../../../services/window.service';
import { AuthService } from '../../../services/auth.service';
import { UserInfo } from '../../../model/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit, AfterViewInit {
  isGetOTPForm: boolean;
  isValidateOTPForm: boolean;
  isSignUpForm: boolean;
  otpCode: string;

  getOTPForm: FormControl;
  validateOTPForm: FormControl;
  signUpForm: FormGroup;

  windowRef: any;

  constructor(private win: WindowService,
              private authService: AuthService,
              private router: Router) { }

  ngOnInit() {
    this.windowRef = this.win.windowRef;
    this.isGetOTPForm = true;
    this.initForm();
  }

  ngAfterViewInit(): void {
    if (this.isGetOTPForm) {
      firebase.initializeApp(firebaseConfig);
      this.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
      this.windowRef.recaptchaVerifier.render()
        .then((widgetId) => {
          this.windowRef.recaptchaWidgetId = widgetId;
        });
    }
  }

  initGetOTPForm() {
    this.getOTPForm = new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]);
  }

  submitGetOTPForm() {
    console.log('submit get OTP code');
    const appVerifier = this.windowRef.recaptchaVerifier;
    const num = '+84'.concat(this.getOTPForm.value.slice(1));
    firebase.auth().signInWithPhoneNumber(num, appVerifier)
      .then(result => {
        this.windowRef.confirmationResult = result;
        this.isGetOTPForm = false;
        this.isSignUpForm = false;
        this.isValidateOTPForm = true;
        this.initForm();
      })
      .catch( error => {
        alert(error);
      });
  }

  initValidateOTPForm() {
    this.validateOTPForm = new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
  }

  submitValidateOTPForm() {
    this.windowRef.confirmationResult
      .confirm(this.validateOTPForm.value)
      .then( result => {
        console.log(result);
        this.isValidateOTPForm = false;
        this.isGetOTPForm = false;
        this.isSignUpForm = true;
        this.initForm();
      })
      .catch( error => alert('Incorrect code entered?'));
  }

  initSignUpForm() {
    this.signUpForm = new FormGroup({
      'fullName': new FormControl('', [Validators.required, Validators.minLength(6)]),
      'username': new FormControl(this.getOTPForm.value, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
      'password': new FormControl('', [Validators.required, Validators.minLength(6)]),
      'confirmPassword': new FormControl('', [Validators.required, Validators.minLength(6)])
    });
  }

  submitSignUpForm() {
    if (this.signUpForm.value.password === this.signUpForm.value.confirmPassword) {
     
    } else {
      alert('Please confirm correct password');
    }
  }

  initForm() {
    if (this.isGetOTPForm) {
      this.initGetOTPForm();
    }
    if (this.isValidateOTPForm) {
      this.initValidateOTPForm();
    }
    if (this.isSignUpForm) {
      this.initSignUpForm();
    }
  }

}
